import { selectedMetricsDataForVitalTab } from "../../PagesContent/DigitalTwinV2/TabSection/_Constants";
import { decimalPlacesForMetrics } from "./DataFile";

const findEntityDisplayName = (data, entityName) => {
  if (!data) return null;

  if (data.name.toLowerCase() === entityName.toLowerCase()) {
    return data.displayName;
  }

  if (data.content && Array.isArray(data.content)) {
    for (const item of data.content) {
      const result = findEntityDisplayName(item, entityName);
      if (result) return result;
    }
  }

  return null;
}

const getCustomerEntityName = (hierarchy, entityName) => {
  const batteryStructure = hierarchy?.batteryStructure
  if (!batteryStructure || !entityName) {
    return null
  }
  for (let pack of batteryStructure) {
    const result = findEntityDisplayName(pack, entityName);
    if (result) return result;
  }
  return null;
};

const findSystemID = (data, entityName) => {
  if (!data) return null;

  if (data.name.toLowerCase() === entityName.toLowerCase()) {
    return data?.systemID;
  }

  if (data.content && Array.isArray(data.content)) {
    for (const item of data.content) {
      const result = findSystemID(item, entityName);
      if (result) return result;
    }
  }

  return null;
}

const getSystemIDForEntity = (hierarchy, entityName) => {
  const batteryStructure = hierarchy?.batteryStructure
  if (!batteryStructure || !entityName) {
    return null
  }
  for (let pack of batteryStructure) {
    const result = findSystemID(pack, entityName);
    if (result) return result;
  }
  return null;
};

const getTruncatedEntityName = (entityName, characterLimit, leftSideLength=5, rightSideLength=12) => {
  return entityName?.length > characterLimit
        ? entityName.substring(0, leftSideLength) +
        "..." +
        entityName.substring(entityName.length - rightSideLength)
        : entityName;
}

const sortBySequence = (arrayToSort, sequenceObject, sequenceKey) => {
  const sequence = sequenceObject[sequenceKey]
  return arrayToSort.sort((a, b) => (sequence.indexOf(a) - sequence.indexOf(b)));
}

const getSelectedMetrics = (checkedMetrics=[], activeMetrics=[]) => {
  let metricsData = selectedMetricsDataForVitalTab.map(metric => ({ 
    ...metric, 
    checked: checkedMetrics.includes(metric.slug),
    status: activeMetrics.includes(metric.slug) ? 'active' : metric.status
  }))

  return metricsData
}


const findSelectedNode = (batteryStructure, selectedNodeID) => {
  console.log({ batteryStructure, selectedNodeID })

  if (!selectedNodeID) {
      return batteryStructure[0] || {};
  }

  const traverse = (nodes) => {
      for (const node of nodes) {
          if (node.id === selectedNodeID) {
              return node;
          }

          if (node.children && node.children.length > 0) {
              const found = traverse(node.children);
              if (found) return found;
          }
      }

      return null;
  };

  return traverse(batteryStructure) || batteryStructure[0] || {};
};

const formatSocValue = (soc) => {
  if (typeof(soc) != 'number') {
    return "NA";
  }

  return `${soc.toFixed(decimalPlacesForMetrics['soc'])}`;
};


export {
  getCustomerEntityName,
  getTruncatedEntityName,
  getSystemIDForEntity,
  sortBySequence,
  getSelectedMetrics,
  findSelectedNode,
  formatSocValue
}
